export const defaultId = 'id';
export const idProp = 'idProp';
export const targetProp = 'to';
export const propertiesProp = 'nestedProps';
